import React from 'react';
import Notifications from '@material-ui/icons/Notifications';

import Lock from '@material-ui/icons/Lock';

import MenuBook from '@material-ui/icons/MenuBook';

import Settings from '@material-ui/icons/Settings';

import DynamicFeed from '@material-ui/icons/DynamicFeed';
import Sports from '@material-ui/icons/Sports';
import Groups from '@material-ui/icons/Group';

import Category from '@material-ui/icons/Category';

import Restaurant from '@material-ui/icons/Restaurant';
import School from '@material-ui/icons/School';

import ShoppingCart from '@material-ui/icons/ShoppingCart';

import DirectionsRun from '@material-ui/icons/DirectionsRun';

import FitnessCenter from '@material-ui/icons/FitnessCenter';
import Book from '@material-ui/icons/Book';
import { MenuItemLink, Responsive, useTranslate } from 'react-admin';
import DashboardIcon from '@material-ui/icons/Dashboard';
import { createTheme, makeStyles, ThemeProvider } from '@material-ui/core';
import { base } from '../util/Styled';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints';
import { getUserConfig } from '../providers/data.provider';

const menuItems = [
	{ name: 'trainees', text: 'TRAINEES', icon: <Groups/> },
	{ name: 'coaches', text: 'COACHES', icon: <Sports/> },
	{ name: 'billboards', text: 'BILLBOARDS', icon: <DynamicFeed/> },
	{ name: 'trainings', text: 'TRAININGS', icon: <FitnessCenter/> },
	{ name: 'live-trainings', text: 'LIVE_TRAININGS', icon: <FitnessCenter/> },
	{ name: 'live-trainings-message', text: 'LIVE_TRAININGS_MESSAGE', icon: <FitnessCenter/> },
	{ name: 'recipes', text: 'RECIPES', icon: <Restaurant/> },
	{ name: 'tags', text: 'TAGS', icon: <Restaurant/> },
	{ name: 'coach-guides', text: 'COACH_GUIDE', icon: <School/> },
	{ name: 'products', text: 'PRODUCTS', icon: <ShoppingCart/> },
	{ name: 'marathons', text: 'MARATHONS', icon: <DirectionsRun/> },
	{ name: 'success-stories', text: 'SUCCESS_STORIES', icon: <Book/> },
	{ name: 'dynamic-cards', text: 'DYNAMIC_CARDS', icon: <DynamicFeed/> },
	{ name: 'training-menus', text: 'TRAINING_MENUS', icon: <MenuBook/> },
	{ name: 'training-categories', text: 'TRAINING_CATEGORIES', icon: <Category/> },
	{ name: 'recipe-categories', text: 'RECIPE_CATEGORIES', icon: <Category/> },
	{ name: 'coach-guide-categories', text: 'COACH_GUIDE_CATEGORIES', icon: <Category/> },
	{ name: 'product-categories', text: 'PRODUCT_CATEGORIES', icon: <Category/> },
	{ name: 'success-story-categories', text: 'SUCCESS_STORY_CATEGORIES', icon: <Category/> },
	{ name: 'organization-notifications', text: 'ORGANIZATION_NOTIFICATIONS', icon: <Notifications/> },
	{ name: 'organization-coach-notifications', text: 'COACH_FOLLOWUPS', icon: <Notifications/> },
	{
		name: 'notifications',
		text: 'NOTIFICATIONS',
		icon: <Notifications/>,
		to: () => `notifications/create`
	},
	{
		name: 'organizations',
		text: 'ORGANIZATION_SETTINGS',
		icon: <Settings/>,
		to: () => `organizations/${getUserConfig()?.user?.organizationId}`
	}
// eslint-disable-next-line eqeqeq
].concat(getUserConfig()?.user?.organizationId == 1 ? [{
	name: 'verifications',
	text: 'VERIFICATIONS',
	icon: <Lock/>
}] : []);

export const theme = createTheme({
	...base as any,
	overrides: {
		MuiListItem: {
			button: {
				padding: '1rem !important',
				color: 'white !important'
			}
		},
		MuiListItemIcon: {
			root: {
				color: 'white'
			}
		}
	}
});

const breakpoints = createBreakpoints({});

const useStyles = makeStyles({
	menuContainer: {
		display: 'flex',
		flexDirection: 'column',
		width: '320px',
		[breakpoints.down(768)]: {
			backgroundImage: 'linear-gradient(135deg, #000000, #13650f)'
		}
	},
	drawer: {
		width: '320px',
	},
	paper: {
		width: '320px',
	},
	sidebar: {
		width: 320,
		closedWidth: 55,
	},
	sideBarLogo: {
		maxHeight: '4rem',
		padding: '1rem'
	},
	sideBarLogoImage: {
		maxHeight: '4rem'
	},
	activeMenuItem: {
		fontWeight: 'bold',
		backgroundColor: '#ffffff66 !important'
	},
	logout: {
		marginTop: 'auto'
	}
});

export const CustomMenu = ({ onMenuClick, logout }) => {
	const translator = useTranslate();
	const classes = useStyles();

	return (
		<ThemeProvider theme={theme}>
			<div className={classes.menuContainer}>
				<div className={classes.sideBarLogo}>
					<img className={classes.sideBarLogoImage} alt="Company Logo" src="/assets/logo.svg"/>
				</div>
				<MenuItemLink
					{...[] as any}
					to="/"
					exact
					activeClassName={classes.activeMenuItem}
					primaryText={translator('DASHBOARD')}
					leftIcon={<DashboardIcon/>}
					onClick={onMenuClick}
				/>
				{menuItems.map(item => (
					<MenuItemLink
						{...[] as any}
						activeClassName={classes.activeMenuItem}
						key={item.name}
						to={`/${item.to ? item.to() : item.name}`}
						primaryText={translator(item.text)}
						leftIcon={item.icon}
						onClick={onMenuClick}
					/>
				))}
				<div className={classes.logout}>
					<Responsive
						small={logout}
						medium={logout}
					/>
				</div>
			</div>
		</ThemeProvider>
	);
};

